import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

// import MEliminarProductoProduccion from "@ListasProduccion/Modales/MEliminarProductoProduccion";

// import MDetalleInferiorProductoProduccion from "@ListasProduccion/Modales/MDetalleInferiorProductoProduccion";
// import MAgregarEditarProductoProduccion from "@ListasProduccion/Modales/MAgregarEditarProductoProduccion";
import MDetallePedidoProduccion from "@ListasProduccion/Modales/MDetallePedidoProduccion";
import MPDFSolicitudEntrega from "@ListasProduccion/Modales/MPDFSolicitudEntrega";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import * as _testing_ from "@Funciones/testing";
import "./ListasProduccion.css";

function ListasProduccion() {
  const origenComponente = "ListasProduccion";
  const { ecv_u, cv_u, usuarioSesion, esComputadora, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    //DATOS USUARIO
    v_formulario: false,
    da_maestros: [],
    d_codigoMaestro: null,
    d_actualizarTabla: false,

    //ESTADO PROCESAOR API
    i_procesandoApi: false,
    i_primeraCarga: true,

    d_fechaInicio: null,
    d_fechaFin: null,
    d_pdfSeleccionado: "",
    d_total_absoluto: 0,
  });

  useEffect(() => {
    const listaProductosMaestroAPI = _api_.f_estructuraListaProducciones({
      parametros: { fecha_inicio: v_u.d_fechaInicio, fecha_fin: v_u.d_fechaFin },
      origen: origenComponente,
      timeout: 5000,
    });
    listaProductosMaestroAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          do_filtros: dPC.contenido.filtros,
          da_grid: dPC.contenido.grid,
          da_headgrid: dPC.contenido.headgrid,
          d_multiselecion: dPC.contenido.multiseleccion,
          d_total_absoluto: dPC.contenido.total_absoluto,
        });
      }
    });
  }, [v_u.d_actualizarTabla, recargaComponente]);

  return (
    <div className="ListasProduccionCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            // erecargaComponente((prev)=> !prev)
            // console.log("entre a cerrar")
            _f_.asignar(ev_c, { modal_mostrar: false });
          }}>
          {/* <MAgregarEditarProductoProduccion
            origenComponente
            registro={{
              codigo: 0,
            }}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, { modal_mostrar: false });
            }}
            fActualizarTablaTotal={(actualizar) => {
              if (actualizar) {
                erecargaComponente((prev) => !prev);
              }
            }}
          /> */}
          <MPDFSolicitudEntrega
            origenComponente={origenComponente}
            parametros={{ pdfSeleccionado: v_u.d_pdfSeleccionado }}
          />
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Lista de Producción"}</div>

      <div className="ListasProduccionCSS-cabecera">
        <_ipt_.Input4
          tipo={"date"}
          texto={"Fecha Inicio"}
          estilos={{ width: "100%" }}
          onBlur={(evento) => {
            // console.log(evento.target.value);
            _f_.asignar(ev_u, { d_fechaInicio: evento.target.value });
          }}
        />
        <_ipt_.Input4
          tipo={"date"}
          texto={"Fecha Fin"}
          estilos={{ width: "100%" }}
          onBlur={(evento) => {
            // console.log(evento.target.value);
            _f_.asignar(ev_u, { d_fechaFin: evento.target.value });
          }}
        />
        <_btn_.Boton
          texto={`Buscar`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            erecargaComponente((prev) => !prev);
            // _f_.asignar(ev_c, {
            //   modal_mostrar: true,
            //   modal_titulo: "Agregar Producto Producción",
            //   modal_estilos: { anchoMI: "40rem", altoMI: "initial" },
            // });
          }}
        />
      </div>
      <div className="ListasProduccionCSS-filtros">
        {/* <Filtros
          filtros={v_u.do_filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtrosActualizados: valores });
          }}
        /> */}
      </div>
      <div className="ListasProduccionCSS-cuerpo">
        <_tabla_.Tabla
          origenComponente={origenComponente}
          cabecera={v_u.da_headgrid}
          registros={v_u.da_grid}
          filtros={v_u.do_filtrosActualizados}
          modoVista={"modo2"}
          permiteActualizacionAlCerrarModal={true}
          permiteMultiseleccion={v_u.d_multiselecion}
          permiteOpciones={true}
          camposCodigosSeleccion={["codigo"]}
          campoCodigoCategoria={"categoria"}
          campoCodigoRegistrosPorCategoria={"registros"}
          campoCodigoDespliegaDetalleRegistro={"codigo"}
          reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
          mapaDeComponentes={{
            MDetallePedidoProduccion,
            // MEliminarProductoProduccion,
            // MDetalleInferiorProductoProduccion,
            // MAgregarEditarProductoProduccion,
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
              _f_.asignar(ev_u, { d_actualizarTabla: !v_u.d_actualizarTabla });
              erecargaComponente((prev) => !prev);
            }
          }}
        />
      </div>
      <div className="ListasProduccionCSS-opciones">
        <_btn_.Boton
          texto={`PDF de solicitud`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_rojo_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "PDF de Solicitud",
              modal_estilos: { anchoMI: "70%", altoMI: "70%" },
            });
            _f_.asignar(ev_u, {
              d_pdfSeleccionado: "pdfsolicitud",
            });
          }}
        />
        {["SADM01"].includes(rolUsuarioSesion) && (
          <_btn_.Boton
            texto={`PDF Entrega`}
            tipo="btn-2"
            estilos={{
              anchoB2: "10rem",
              color: "var(--color_rojo_1)",
              fuente: "1rem",
            }}
            onClick={() => {
              _f_.asignar(ev_c, {
                modal_mostrar: true,
                modal_titulo: "PDF de Entrega",
                modal_estilos: { anchoMI: "70%", altoMI: "70%" },
              });
              _f_.asignar(ev_u, {
                d_pdfSeleccionado: "pdfentrega",
              });
            }}
          />
        )}
        {["SADM01"].includes(rolUsuarioSesion) && (
          <div>
            {" "}
            <_div_.Div2
              texto={`Total: ${_f_.formatearValor({ valor: v_u.d_total_absoluto, tipo: "moneda", moneda: "PEN", precision: 2 })}`}
              estilos={{ altoDiv2: "100%" }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ListasProduccion;
